import { Controller } from "@hotwired/stimulus"

// Holds the device's screen-wake lock open while the recipe is on screen.
// Phones dim and lock by default; users cooking from a recipe page need
// the screen alive without poking it every 30 seconds with floury hands.
//
// The Wake Lock API auto-releases on tab visibility loss (background, lock
// screen). Re-acquire on visibilitychange so flipping back to the recipe
// keeps the screen awake without a reload.
export default class extends Controller {
  connect() {
    if (!("wakeLock" in navigator)) return

    this.onVisibilityChange = () => {
      if (document.visibilityState === "visible") this.acquire()
    }
    document.addEventListener("visibilitychange", this.onVisibilityChange)
    this.acquire()
  }

  disconnect() {
    if (this.onVisibilityChange) {
      document.removeEventListener("visibilitychange", this.onVisibilityChange)
      this.onVisibilityChange = null
    }
    this.release()
  }

  async acquire() {
    if (this.lock) return
    try {
      this.lock = await navigator.wakeLock.request("screen")
      this.lock.addEventListener("release", () => { this.lock = null })
    } catch {
      // Some browsers/contexts (low battery, no user gesture, iframe) deny
      // the request — failing closed is fine, the user just gets default
      // screen-dim behavior.
    }
  }

  release() {
    if (!this.lock) return
    try { this.lock.release() } catch { /* lock already released */ }
    this.lock = null
  }
}
